module.exports = __webpack_public_path__ + "img/white-wave-pricing.52714d87.svg";